import { ControlPosition, FeatureGroup, tileLayer } from "leaflet";
import { environment } from "../../../../environments/environment";

const urlTemplate = environment.mapTilesAddress;
const position: ControlPosition = "topright";
export const LorenMap = {
  urlTemplate,
  googleStreetViewLink:
    "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=",
  circleColor: "#999999",
  drawOptions: {
    position,
    marker: {},
    draw: {
      polyline: {
        shapeOptions: {
          color: "#f357a1",
          weight: 10,
        },
      },
      polygon: {
        showArea: true,
        metric: ["km", "m"],
        // allowIntersection: false, // Restricts shapes to simple polygons
        drawError: {
          color: "#e1e100", // Color the shape will turn when intersects
          // Message that will show when intersect
          // (allowIntersection: false)
          message: "geofencing.draw_polygon_intersect_error",
        },
        shapeOptions: {
          color: "#00b9a5",
        },
      },
      circle: {
        metric: true,
        shapeOptions: {
          color: "#999999",
        },
      },
      rectangle: {
        showArea: false,
        metric: ["km", "m"],
        shapeOptions: {
          clickable: false,
        },
      },
      marker: false,
      circlemarker: false,
      edit: {
        featureGroup: new FeatureGroup(),
        edit: false,
        // remove: false
      },
      handlers: {
        polygon: {
          tooltip: {
            start: "geofencing.draw_polygon_start",
            cont: "geofencing.draw_polygon_cont",
            end: "geofencing.draw_polygon_end",
          },
        },
        circle: {
          tooltip: {
            start: "geofencing.draw_circle_start",
          },
          radius: "geofencing.radius",
        },
        rectangle: {
          tooltip: {
            start: "geofencing.draw_rectangle_start",
          },
        },
        simpleshape: {
          tooltip: {
            end: "geofencing.draw_shape_end",
          },
        },
      },
    },
  },
  mapOptions: {
    layers: [
      tileLayer(urlTemplate, {
        maxZoom: 18,
        attribution: "...",
      }),
    ],
  },
  maxZoom: 19,
  refreshTimeout: 5000,
};
